export const listTranslate = [
  { label: 'Afrikaans', value: 'af', code: 'af.png' },
  { label: 'Albanian', value: 'sq', code: 'sq.png' },
  { label: 'Amharic', value: 'am', code: 'am.png' },
  { label: 'Arabic', value: 'ar', code: 'ar.png' },
  { label: 'Armenian', value: 'hy', code: 'hy.png' },
  { label: 'Azerbaijani', value: 'az', code: 'az.png' },
  { label: 'Basque', value: 'eu', code: 'eu.png' },
  { label: 'Belarusian', value: 'be', code: 'be.png' },
  { label: 'Bengali', value: 'bn', code: 'bn.png' },
  { label: 'Bosnian', value: 'bs', code: 'bs.png' },
  { label: 'Bulgarian', value: 'bg', code: 'bg.png' },
  { label: 'Catalan', value: 'ca', code: 'ca.png' },
  { label: 'Cebuano', value: 'ceb', code: 'ceb.png' },
  { label: 'Chichewa', value: 'ny', code: 'ny.png' },
  { label: 'Chinese (Simplified)', value: 'zh-CN', code: 'zh-CN.png' },
  { label: 'Chinese (Traditional)', value: 'zh-TW', code: 'zh-TW.png' },
  { label: 'Corsican', value: 'co', code: 'co.png' },
  { label: 'Croatian', value: 'hr', code: 'hr.png' },
  { label: 'Czech', value: 'cs', code: 'cs.png' },
  { label: 'Danish', value: 'da', code: 'da.png' },
  { label: 'Dutch', value: 'nl', code: 'nl.png' },
  { label: 'English', value: 'en', code: 'en.png' },
  { label: 'Esperanto', value: 'eo', code: 'eo.png' },
  { label: 'Estonian', value: 'et', code: 'et.png' },
  { label: 'Filipino', value: 'tl', code: 'tl.png' },
  { label: 'Finnish', value: 'fi', code: 'fi.png' },
  { label: 'French', value: 'fr', code: 'fr.png' },
  { label: 'Frisian', value: 'fy', code: 'fy.png' },
  { label: 'Galician', value: 'gl', code: 'gl.png' },
  { label: 'Georgian', value: 'ka', code: 'ka.png' },
  { label: 'German', value: 'de', code: 'de.png' },
  { label: 'Greek', value: 'el', code: 'el.png' },
  { label: 'Gujarati', value: 'gu', code: 'gu.png' },
  { label: 'Haitian Creole', value: 'ht', code: 'ht.png' },
  { label: 'Hausa', value: 'ha', code: 'ha.png' },
  { label: 'Hawaiian', value: 'haw', code: 'haw.png' },
  { label: 'Hebrew', value: 'iw', code: 'iw.png' },
  { label: 'Hindi', value: 'hi', code: 'hi.png' },
  { label: 'Hmong', value: 'hmn', code: 'hmn.png' },
  { label: 'Hungarian', value: 'hu', code: 'hu.png' },
  { label: 'Icelandic', value: 'is', code: 'is.png' },
  { label: 'Igbo', value: 'ig', code: 'ig.png' },
  { label: 'Indonesian', value: 'id', code: 'id.png' },
  { label: 'Irish', value: 'ga', code: 'ga.png' },
  { label: 'Italian', value: 'it', code: 'it.png' },
  { label: 'Japanese', value: 'ja', code: 'ja.png' },
  { label: 'Javanese', value: 'jw', code: 'jw.png' },
  { label: 'Kannada', value: 'kn', code: 'kn.png' },
  { label: 'Kazakh', value: 'kk', code: 'kk.png' },
  { label: 'Khmer', value: 'km', code: 'km.png' },
  { label: 'Korean', value: 'ko', code: 'ko.png' },
  { label: 'Kurdish (Kurmanji)', value: 'ku', code: 'ku.png' },
  { label: 'Kyrgyz', value: 'ky', code: 'ky.png' },
  { label: 'Lao', value: 'lo', code: 'lo.png' },
  { label: 'Latin', value: 'la', code: 'la.png' },
  { label: 'Latvian', value: 'lv', code: 'lv.png' },
  { label: 'Lithuanian', value: 'lt', code: 'lt.png' },
  { label: 'Luxembourgish', value: 'lb', code: 'lb.png' },
  { label: 'Macedonian', value: 'mk', code: 'mk.png' },
  { label: 'Malagasy', value: 'mg', code: 'mg.png' },
  { label: 'Malay', value: 'ms', code: 'ms.png' },
  { label: 'Malayalam', value: 'ml', code: 'ml.png' },
  { label: 'Maltese', value: 'mt', code: 'mt.png' },
  { label: 'Maori', value: 'mi', code: 'mi.png' },
  { label: 'Marathi', value: 'mr', code: 'mr.png' },
  { label: 'Mongolian', value: 'mn', code: 'mn.png' },
  { label: 'Myanmar (Burmese)', value: 'my', code: 'my.png' },
  { label: 'Nepali', value: 'ne', code: 'ne.png' },
  { label: 'Norwegian', value: 'no', code: 'no.png' },
  { label: 'Pashto', value: 'ps', code: 'ps.png' },
  { label: 'Persian', value: 'fa', code: 'fa.png' },
  { label: 'Polish', value: 'pl', code: 'pl.png' },
  { label: 'Portuguese', value: 'pt', code: 'pt.png' },
  { label: 'Punjabi', value: 'pa', code: 'pa.png' },
  { label: 'Romanian', value: 'ro', code: 'ro.png' },
  { label: 'Russian', value: 'ru', code: 'ru.png' },
  { label: 'Samoan', value: 'sm', code: 'sm.png' },
  { label: 'Scottish Gaelic', value: 'gd', code: 'gd.png' },
  { label: 'Serbian', value: 'sr', code: 'sr.png' },
  { label: 'Sesotho', value: 'st', code: 'st.png' },
  { label: 'Shona', value: 'sn', code: 'sn.png' },
  { label: 'Sindhi', value: 'sd', code: 'sd.png' },
  { label: 'Sinhala', value: 'si', code: 'si.png' },
  { label: 'Slovak', value: 'sk', code: 'sk.png' },
  { label: 'Slovenian', value: 'sl', code: 'sl.png' },
  { label: 'Somali', value: 'so', code: 'so.png' },
  { label: 'Spanish', value: 'es', code: 'es.png' },
  { label: 'Sudanese', value: 'su', code: 'su.png' },
  { label: 'Swahili', value: 'sw', code: 'sw.png' },
  { label: 'Swedish', value: 'sv', code: 'sv.png' },
  { label: 'Tajik', value: 'tg', code: 'tg.png' },
  { label: 'Tamil', value: 'ta', code: 'ta.png' },
  { label: 'Telugu', value: 'te', code: 'te.png' },
  { label: 'Thai', value: 'th', code: 'th.png' },
  { label: 'Turkish', value: 'tr', code: 'tr.png' },
  { label: 'Ukrainian', value: 'uk', code: 'uk.png' },
  { label: 'Urdu', value: 'ur', code: 'ur.png' },
  { label: 'Uzbek', value: 'uz', code: 'uz.png' },
  { label: 'Vietnamese', value: 'vi', code: 'vi.png' },
  { label: 'Welsh', value: 'cy', code: 'cy.png' },
  { label: 'Xhosa', value: 'xh', code: 'xh.png' },
  { label: 'Yiddish', value: 'yi', code: 'yi.png' },
  { label: 'Yoruba', value: 'yo', code: 'yo.png' },
  { label: 'Zulu', value: 'zu', code: 'zu.png' }
];
